import React from "react";
import styled from "styled-components";
import { Small, H4 } from "../";
export const Avatar = ({
  title,
  subtitle,
  image,
  icon,
  ...props
}) => {
  return React.createElement(AvatarWrap, props, React.createElement(Image, null, image), React.createElement(H4, null, React.createElement(Icon, null, icon), title), React.createElement(StyledSmall, null, subtitle));
};
const AvatarWrap = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  position: relative;
  max-width: 496px;
`;
const Image = styled.div`
  border-radius: 100px;
  height: 104px;
  margin-bottom: 16px;
  overflow: hidden;
  width: 104px;
  img {
    width: 100%;
  }
`;
const Icon = styled.div`
  align-items: center;
  display: inline-flex;
  height: 16px;
  margin-right: 8px;
  position: relative;
  top: 2px;
  width: 16px;
`;
const StyledSmall = styled(Small)`
  margin-top: 8px;
`;